import Resource from './resource';

export default class StudentResource extends Resource{
	constructor(){
		super('students');
	}
}